<div class="bg_login d-flex">
  <div class="w-50 h-100 login_div">
    <div class="login_form">
      <div class="text-center mb-4">
        <img src="assets/images/logo/resy_logo.png">
      </div>
      <h3 class="forgot_pass mb-3">{{'INFO.FORGOT_PASSWORD_QUESTION' | translate}}
        <!-- <app-change-language [ShowFullName]="false"></app-change-language> -->
      </h3>
      <p class="forgot_pass_p">{{'INFO.FORGOT_PASSWORD_MESSAGE' | translate}}</p>
      <div class="login_field">
        <label class="lbl_resy_field">{{'LOGIN.EMAIL'|translate}}
          <i *ngIf="errorModel!=null && errorModel['Email']!=null && !email.errors?.pattern"
            class="pi pi-exclamation-circle float-end me-1 error_color pt-1"
            pTooltip="{{errorModel['Email']|translate}}" tooltipPosition="top"></i>
          <i *ngIf="email.touched && email.errors?.pattern && (errorModel==null || errorModel['Email']==null)"
            class="pi pi-exclamation-circle float-end me-1 error_color pt-1"
            pTooltip="{{'INFO.INVALID_EMAIL'|translate}}" tooltipPosition="top"></i>
        </label>
        <input type="email" class="input_field" [(ngModel)]="forgotPasswordModel.email" #email=ngModel required pattern="^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$">
        <button class="btn_login mt-3" [disabled]="spinner || (errorModel!=null && errorModel['Email']!=null) || email.errors"
          (click)="sendForgotPasswordRequest(forgotPasswordModel)">{{'INFO.SEND_MAIL'|translate}}</button>
        <a type="button" routerLink="/login" class="signup_link text-center mt-2">{{'INFO.SIGN_IN' | translate }}</a>
        <div class="small_spinner_wrapper_no_auth" *ngIf="spinner">
          <p-progressSpinner class="w-100 text-center pos_spinner_small"></p-progressSpinner>
        </div>
      </div>
    </div>
  </div>
</div>
